var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.step,
            callback: function($$v) {
              _vm.step = $$v
            },
            expression: "step"
          }
        },
        [
          _c(
            "v-stepper-header",
            _vm._l(_vm.steps, function(stepContent, i) {
              return _c(
                "v-stepper-step",
                {
                  key: stepContent,
                  attrs: { complete: _vm.step > i + 1, step: i + 1 }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("roomWizard." + stepContent)) + " "
                  )
                ]
              )
            }),
            1
          ),
          _c(
            "v-stepper-items",
            _vm._l(_vm.steps, function(stepContent, i) {
              return _c(
                "v-stepper-content",
                { key: stepContent, attrs: { step: i + 1 } },
                [
                  stepContent == "license"
                    ? _c("step-license", {
                        attrs: {
                          "device-configuration": _vm.deviceConfiguration,
                          index: i,
                          steps: _vm.steps
                        },
                        on: {
                          onNext: _vm.nexStep,
                          onPrev: _vm.prevStep,
                          onChoseLicense: _vm.associateLicense
                        }
                      })
                    : _vm._e(),
                  stepContent == "display"
                    ? _c("step-display", {
                        attrs: {
                          "device-configuration": _vm.deviceConfiguration,
                          "wizard-configuration": _vm.wizardConfiguration,
                          index: i,
                          steps: _vm.steps
                        },
                        on: {
                          onNext: _vm.nexStep,
                          onPrev: _vm.prevStep,
                          onUpdateConfig: function($event) {
                            _vm.wizardConfiguration = $event
                          }
                        }
                      })
                    : _vm._e(),
                  stepContent == "updates"
                    ? _c("step-updates", {
                        attrs: {
                          "device-configuration": _vm.deviceConfiguration,
                          index: i,
                          steps: _vm.steps
                        },
                        on: {
                          onNext: _vm.nexStep,
                          onPrev: _vm.prevStep,
                          onRestart: _vm.restart
                        }
                      })
                    : _vm._e(),
                  stepContent == "credentials"
                    ? _c("step-credentials", {
                        attrs: {
                          "wizard-configuration": _vm.wizardConfiguration,
                          index: i,
                          steps: _vm.steps
                        },
                        on: {
                          onNext: _vm.nexStep,
                          onPrev: _vm.prevStep,
                          onUpdateConfig: function($event) {
                            _vm.wizardConfiguration = $event
                          }
                        }
                      })
                    : _vm._e(),
                  stepContent == "meeting"
                    ? _c("step-meeting", {
                        attrs: {
                          "device-configuration": _vm.deviceConfiguration,
                          "wizard-configuration": _vm.wizardConfiguration,
                          "allowed-providers": _vm.meetingProviders,
                          index: i,
                          "active-step": _vm.step,
                          steps: _vm.steps
                        },
                        on: {
                          onNext: _vm.nexStep,
                          onPrev: _vm.prevStep,
                          onUpdateConfig: function($event) {
                            _vm.wizardConfiguration = $event
                          }
                        }
                      })
                    : _vm._e(),
                  stepContent == "calendar"
                    ? _c("step-calendar", {
                        attrs: {
                          "device-configuration": _vm.deviceConfiguration,
                          "wizard-configuration": _vm.wizardConfiguration,
                          "allowed-providers": _vm.calendarProviders,
                          index: i,
                          "active-step": _vm.step,
                          steps: _vm.steps
                        },
                        on: {
                          onNext: _vm.nexStep,
                          onPrev: _vm.prevStep,
                          onUpdateConfig: function($event) {
                            _vm.wizardConfiguration = $event
                          }
                        }
                      })
                    : _vm._e(),
                  stepContent == "language"
                    ? _c("step-languages", {
                        attrs: {
                          "wizard-configuration": _vm.wizardConfiguration,
                          index: i,
                          steps: _vm.steps
                        },
                        on: {
                          onNext: _vm.nexStep,
                          onPrev: _vm.prevStep,
                          onUpdateConfig: function($event) {
                            _vm.wizardConfiguration = $event
                          }
                        }
                      })
                    : _vm._e(),
                  stepContent == "appearance"
                    ? _c("step-appearance", {
                        attrs: {
                          "wizard-configuration": _vm.wizardConfiguration,
                          "device-configuration": _vm.deviceConfiguration,
                          index: i,
                          steps: _vm.steps
                        },
                        on: {
                          onNext: _vm.nexStep,
                          onPrev: _vm.prevStep,
                          onUpdateConfig: function($event) {
                            _vm.wizardConfiguration = $event
                          }
                        }
                      })
                    : _vm._e(),
                  stepContent == "complete"
                    ? _c("step-complete", {
                        attrs: { "show-back-to-rooms": _vm.showBackToRooms }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }